import React from "react";

// Custom Components
import LoginComponent from "../../../Components/Pages/Auth/Login/index";

function Login() {
  return (
    <>
      <LoginComponent />
    </>
  );
}

export default Login;
